import React, { useState, useEffect, useContext, useRef } from 'react'
import styles from '../index.module.less'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { Tooltip, message, Modal, Button } from 'antd'
import { SGeneralForms } from 'shj-components'
import {updateLastCallTime, viewPhoneByClueId} from '@/services/callCenter'
import MarketingModal from '../../../marketingModal'
import { modalCallPendingSubmissionModelFn } from './submitPending'
import { SubmitInvalidModalFn } from './submitInvalid'
import { submitValidModalFn } from './submitValid'
import { modalReservationCustomerFn } from './reservationCustomer'//预约到店
import { dispatchModalFn } from './dispatch'
import { dispatchStatusColor } from '@/pages/crm/callCenter/callManage/utils'
// import { AddOrEditDrawer as Edit } from '@/pages/informationManagement/clueInfo/component/addOrEdit'
import { getAuth } from '@/utils/auth'
import { viewPhoneClueInfo } from '@/services/member.ts'
import { get } from 'lodash-es'
// import { SOFT_PHONE_EVENTS, triggerEvent } from '@/components/shj-soft-phone'
// import { useSetState } from 'ahooks'
import { triggerPhoneCall } from '@/components/shj-soft-phone'
import {getUser} from "@/common/utils.ts";
import AddClueModal from "@/pages/crm/callCenter/callManage/components/head/addClueModal.tsx";
import AddNewPlanModal from "@/components/AddNewPlanModal";
import {openAppointmentCallModal} from "./appointmentCallModal.tsx";
import FollowUpDiary from "@/pages/crm/callCenter/callManage/components/mainRight/components/Bottom/FollowUpDiary";

function Top(props: any) {
  const { updateCallManageState, callManageState } = useContext(callContext)
  const auth = getAuth()
  const {
    callAllState,
    callList,
    callDetails,
    discardCauseList,
    pendingCauseList,
    refreshList,
    detailRefresh,
    followUpDiaryRefresh,
    detailParameter,
    callBtnState,
    isCallSystemUser = true,
  } = callManageState
  const [addClueVisible, setAddClueVisible] = useState(false)
  const [openMarketingModal, setOpenMarketingModal] = useState(false)

  const { isBtnObj } = props
  // console.log('isBtnObj===========?', isBtnObj, callList)

  useEffect(()=>{
    // console.log(43,isBtnObj ,auth['CallClueAssign'],callDetails);
  },[isBtnObj,callDetails])
  const formRef = useRef()
  useEffect(() => {
    if (!callDetails.id) {
      formRef?.current?.onReset()
    }
  }, [callDetails])
  // 刷新列表和详情
  const refreshListOrDetail = () => {
    updateCallManageState({
      refreshList: !refreshList,
      detailRefresh: !detailRefresh,
    })
  }

  const callUp = () => {
    const {
      name: clueName,
      seatName: agentName,
      seatWorkNumber: tenantId,
      // channel,
      id,
      customer,
    }: any = callDetails
    // if (phoneState.phoneCall && softPhone.isLogin) return
    // updateCallAllState({ presentPageUrl: '/call_sys/clue' })
    const userInfo = getUser?.()
    const interfaceData = {
      bizId: id,
      id: id,
      clueName: clueName,
      agentName: get(userInfo, 'userName'),
      tenantId: get(userInfo, 'userIdentityId'),
      agentType: 'SEAT',
    }
    const channel =  callDetails.channel || callDetails.channelClue?.channelName
    const panelShowData = { ...interfaceData, channel }
    // api.post(APIS.marketCloudClueInfoUpdateLastCallTime, { data: { clueId: callDetails.id } });
    callBtnState.loading = true
    updateCallManageState({ ...callBtnState })

    viewPhoneByClueId(callDetails['id']).then((res: any) => {
      console.log('call_up:', res)
    //   if (res.status == 200) {
    //   console.log(interfaceData, panelShowData, callDetails)
      triggerPhoneCall({
        phone: res,
        interfaceData,
        panelShowData,
        detailData: callDetails,
        disloutSuccess: () => {
          updateLastCallTime(callDetails.id)
          updateCallManageState({
            callBtnState: { ...callBtnState, loading: false, disabled: true },
          })
        },
        disloutAbort: () => {
          updateCallManageState({
            callBtnState: { ...callBtnState, loading: false, disabled: false },
          })
        },
      })
        // triggerEvent(SOFT_PHONE_EVENTS.SOFT_PHONE_DIALOUT, {
        //   phone: res.data,
        //   interfaceData,
        // })

        // updatePhoneState({
        //   phoneCall: {
        //     phone: res.data.data,
        //     interfaceData,
        //     panelShowData,
        //     detailData: callDetails,
        //   },
        // })
      // }
    })
  }
  // 提交待定
  const submitPending = () => {
    modalCallPendingSubmissionModelFn({
      fn: () => {
        updateCallManageState({ refreshList: !refreshList })
      },
      buttonKey: 'CALL_PENDING',
      list: pendingCauseList || [],
      id: callDetails?.id,
    })
  }
  // 派单
  const sendOrders = () => {
    dispatchModalFn({
      content: `确定更改${callDetails.statusName}状态为派单状态?`,
      clueId: callDetails?.id,
      buttonKey: 'DISPATCH',
      fn: () => {
        refreshListOrDetail()
      },
    })
  }
  // 提交无效
  const submitInvalid = () => {
    SubmitInvalidModalFn({
      fn: () => {
        refreshListOrDetail()
      },
      buttonKey: 'CALL_INVALID',
      discardCauseList: discardCauseList,
      id: callDetails?.id,
    })
  }
  // 是否能编辑
  const isEdit = () => {
    const values = callDetails.status
    return (
      values !== 'CLUE' && //线索
      values !== 'SALE_MAN_PENDING' && //待定线索
      values !== 'ORDINARY_MSG' && //确认需求（有效线索）
      values !== 'VALID_MSG' && //预约线索
      values !== 'DESIGN' && //已转设计
      values !== 'TO_SHOP' && //到店
      values !== 'INVALID' //无效
    )
  }
  // 预约到店
  const onReservation = () => {
    modalReservationCustomerFn({
      fn: () => {
        updateCallManageState({ refreshList: !refreshList })
      },
      buttonKey: 'APPOINTMENT_STORE',
      data: callDetails
    })
  }
  // 提交有效
  const onSubmitValid = () => {
    submitValidModalFn({
      content: `确定更改${callDetails.statusName}状态为呼叫有效状态?`,
      clueId: callDetails?.id,
      fn: () => {
        refreshListOrDetail()
      },
    })
  }

  // 云客服邀约
  const onOpenAppointmentCall = () => {
    openAppointmentCallModal({
      clueId: callDetails?.id,
      fn: () => {
        updateCallManageState({
          followUpDiaryRefresh: !followUpDiaryRefresh,//刷新跟进日志
        })
      },
    });
  }
  return (
    <div className={styles.top}>
      <div className={styles.idOrSelect}>
        <div className={styles.id}>
          ID：{callDetails.id}
          {callDetails.repeatIds ? (
            <Tooltip title={`重复线索ID：${callDetails.repeatIds || ''}`}>
              <div className={styles.redText}>(重复客户)</div>
            </Tooltip>
          ) : null}
          <div
            className={styles.rowTag}
            style={{
              color: dispatchStatusColor({ value: callDetails.statusName, isText: true }),
              borderColor: dispatchStatusColor({ value: callDetails.statusName }),
              background: dispatchStatusColor({
                value: callDetails.statusName,
                isBackground: true,
              }),
            }}
          >
            {callDetails.statusName}
          </div>
        </div>
        {callList?.length && callAllState.tabValue != '公海' ? (
          <div className={styles.select}>
            {/*{callManageState.isCallSystemUser ? (*/}

            {
              isBtnObj['CALL_APPOINTMENT'] ?
                  <Button
                      size="small"
                      style={{ margin: "0 5px" }}
                      onClick={() => onOpenAppointmentCall()}
                  >
                    云客服邀约
                  </Button>
                  : null
            }

            {isBtnObj['DIALING'] ? (
              <Button
                size="small"
                style={{ margin: "0 5px" }}
                onClick={() => callUp()}
                {...callBtnState}
              >
                <span style={{ lineHeight: 1 }}>拨打电话</span>
              </Button>
            ) : null}

            {/* 线索状态为信息和待定显示 */}
            {
              isBtnObj['CALL_PENDING'] ?
                <Button
                  size="small"
                  style={{ margin: "0 5px" }}
                  disabled={!callDetails.id}
                  onClick={submitPending}
                >
                  提交待定
                </Button>
                : null
            }

            {
              isBtnObj['APPOINT_DISPATCH'] ?
                <Button
                  disabled={callAllState.detailsDispatchStatus == '派单'}
                  size="small"
                  style={{ margin: "0 5px" }}
                  onClick={() => setOpenMarketingModal(true)}
                >
                  指定派单
                </Button>
                : null
            }

            {isBtnObj['DISPATCH'] ?
              <Button
                size="small"
                style={{ margin: "0 5px" }}
                onClick={() => sendOrders()}
              >
                派单
              </Button>
              : null}
            {isBtnObj['CALL_INVALID'] ?
              <Button
                size="small"
                style={{ margin: "0 5px" }}
                onClick={() => submitInvalid()}
              >
                提交无效
              </Button>
              : null}
            {/* 线索状态为有效显示 */}
           {/* {
              isBtnObj['APPOINTMENT_STORE']? (
                <Button
                  size="small"
                  style={{ margin: "0 5px" }}
                  onClick={onReservation}
                >
                  预约到店
                </Button>
              ):null
            }*/}
            {
              isBtnObj['CALL_VALID'] ? (
                <Button
                  size="small"
                  style={{ margin: "0 5px" }}
                  onClick={onSubmitValid}
                >
                  提交有效
                </Button>
              ):null
            }
            {isEdit() && auth['CallClueEdit']
              ? (
                <Button
                  size="small"
                  style={{ margin: "0 5px" }}
                  onClick={() => {
                    setAddClueVisible(true)
                  }}
                >
                  编辑
                </Button>
              )
              : null}
          </div>
        ) : null}
      </div>
      <div style={{ marginTop: '10px' }}>
        <SGeneralForms
          ref={formRef}
          detailsData={{...callDetails, ...callDetails.channelClue}}
          isDetail={true}
          configs={[
            {
              formItem: [
                { name: 'cityName', label: '报名城市', spanCol: 8 },
                { name: 'channelName', label: '客户来源', spanCol: 8 },
                { name: 'signTime', label: '报名时间', spanCol: 8 },
                { name: 'applyUrl', label: '报名页面', spanCol: 8 },
                { name: 'applyPageDesc', label: '报名页说明', spanCol: 8 },
                { name: 'applyUrl', label: '报名URL', spanCol: 8 },
                { name: 'landPageUrl', label: '着陆URL', spanCol: 8 },
                { name: 'searchWord', label: '搜索用词', spanCol: 8 },
                { name: 'creativeVideo', label: '信息流广告视频', spanCol: 8 },
                { name: 'dispatchTime', label: '派单时间', spanCol: 8, type: 'dateTime' },
                { name: 'seatName', label: '当前云客服', spanCol: 8 },
                {
                  name: 'isRepeat',
                  label: '是否重复',
                  spanCol: 8,
                  children: (
                    <span>
                      {callDetails?.isRepeat ? '是' : callDetails?.isRepeat === false ? '否' : ''}
                    </span>
                  ),
                },
              ],
            },
          ]}
        />
      </div>

      <MarketingModal
        open={openMarketingModal}
        buttonKey={'APPOINT_DISPATCH'}
        onCancel={() => {
          setOpenMarketingModal(false)
        }}
        fn={() => {
          updateCallManageState({ detailRefresh: !detailRefresh, refreshList: !refreshList })
        }}
      />
      {addClueVisible && <AddNewPlanModal basicInfo={callDetails || {}}
                                          viewPhoneKey={'callViewPhone'}
                                          editPhoneKey={'callEditPhone'}
                                      reload={ refreshListOrDetail }
                                      isEdit={true} open={addClueVisible}
                                      onClose={() => setAddClueVisible(false)}
      />}
    </div>
  )
}

export default Top
